export default __webpack_public_path__ + "static/media/venesh_logo.8e02cc7b.png";